<template>
  <content-layout class="no-bg">
    <div v-if="activated" class="result activated">
      <div class="title">Карта успешно активирована</div>
      <p class="message">
        {{ card.name }}, теперь Вы можете частично или полностью оплачивать покупки в парфюмерном супермаркете "Золотое
        яблоко", показав QR-код и CVC-код на кассе.
      </p>
      <div class="purple">
        Эта страница отправлена вам на почту.
      </div>
      <div class="purple">
        CVC-код отправлен Вам в SMS
      </div>
      <div v-html="qr" class="qr"></div>

      <p class="info">
        Хотите сделать такой же подарок?<br>
        Воспользуйтесь нашим сервисом
      </p>
      <a href="https://cards.goldapple.ru/" class="link">cards.goldapple.ru</a>
    </div>

    <div v-else class="result">
      <div class="title">{{ name }}, Вам подарок!</div>
      <div class="description">
        Вам отправлена подарочная карта парфюмерного супермаркета "Золотое Яблоко"
      </div>
      <div v-if="text" class="text">
        <img src="/static/img/icons/copy-left.svg" alt="" class="commas left">
        <div class="inner">{{ text }}</div>
        <img src="/static/img/icons/copy-right.svg" alt="" class="commas right">
      </div>
      <div v-if="sign" :class="{ 'sign': true, 'without-text': !text }">
        {{ sign }}
      </div>
      <img :src="card.design" alt="Ваша карта" class="card">
      <div class="cost">{{ card.amount | costFormat }} РУБ.</div>
      <p class="message">{{ name }}, чтобы воспользоваться картой, Вам необходимо её активировать.</p>
      <form v-if="card.ttl > 0" class="code-wrap send" @submit.prevent="checkCode">
        <p class="message phone">
          SMS-код действителен <span class="time">{{ card.ttl }} сек</span>
        </p>
        <div class="confirm" :class="{ error : wrongCode }">
          <input v-model="code" type="number" class="code" placeholder="SMS-код" name="code" @keyup="formatCode">
          <div class="resend-wrap">
            <button class="btn button" :disabled="pending">{{ pending ? 'Проверка кода...' : 'Подтвердить'}}</button>
          </div>
        </div>
      </form>

      <div v-else class="code-wrap">
        <p v-if="codeSended && card.ttl <= 0" class="message phone">
          Срок действия кода истек,<br>
          получите код активации заново
        </p>
        <p v-else class="message phone">
          На Ваш телефон +375 *** *** {{ hiddenPhone }}<br>
          будет выслан код подтверждения
        </p>
        <form method="post" @submit.prevent="sendCode">
          <div v-if="needEmail" class="input input--chisato" :class="{ 'input--filled': !!email, 'invalid': $v.email.$error }">
            <input class="field input__field input__field--chisato" id="buyer-email" name="email" type="email" v-model="email" @input="$v.email.$touch()" >
            <label class="input__label input__label--chisato" for="buyer-email">
              <span class="input__label-content input__label-content--chisato" data-content="E-mail">E-mail</span>
            </label>
          </div>
          <button class="btn button get-code" :disabled="needEmail && !!$v.email.$error">Получить код активации</button>
        </form>
      </div>
    </div>
  </content-layout>
</template>

<script>
import axios from 'axios'
import { apiUrl } from '@/config.js'
import ContentLayout from '@/components/ContentLayout.vue'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'modal-city',
  mixins: [validationMixin],
  data () {
    return {
      activated: false,
      codeSended: true,
      needEmail: false,
      pending: false,
      voice: false,
      cityTitle: '',
      name: '',
      text: '',
      sign: '',
      email: '',
      card: {
        amount: 0,
        design: '',
        name: '',
        phone: '',
        ttl: 0
      },
      wrongCode: false,
      code: null,
      qr: ''
    }
  },
  validations: {
    email: {
      required,
      email
    }
  },
  components: {
    ContentLayout: ContentLayout
  },
  computed: {
    hiddenPhone () {
      const phone = this.card.phone
      return phone.substring(phone.length - 4)
    }
  },
  created () {
    axios.post(`${apiUrl}/activation`, { token: this.$route.query.token })
      .then(({ data }) => {
        this.card = data.result
        this.codeSended = !!data.result.ttl
        this.needEmail = !!data.result.needEmail
        this.cityTitle = data.result.cityTitle
        this.name = data.result.name
        this.text = data.result.text
        this.sign = data.result.sign
        if (data.result.activated) {
          this.qr = data.result.qr
          this.activated = true
        }
        setInterval(() => {
          if (this.card.ttl > 0) {
            this.$set(this.card, 'ttl', this.card.ttl - 1)
          } else {
            this.wrongCode = false
          }
        }, 1000)
      })
    // .catch((err) => {
    //   if (err.response.data.status === 'error') this.$router.push({ name: 'ModalError', query: { code: 2 } })
    // })
  },
  mounted () {
    this.$v.email.$touch()
  },
  methods: {
    sendCode () {
      axios.post(`${apiUrl}/send_code`, {
        token: this.$route.query.token,
        email: this.email,
        voice: this.voice
      })
        .then(({ data }) => {
          this.$set(this.card, 'ttl', data.ttl)
          this.codeSended = true
          this.voice = true
        })
        .catch(console.error)
    },
    checkCode () {
      this.pending = true
      axios.post(`${apiUrl}/check_code`, {
        token: this.$route.query.token,
        code: this.code
      })
        .then(({ data }) => {
          this.qr = data.qr
          this.wrongCode = true // wtf
          this.activated = true
        })
        .catch(() => {
          this.pending = false
          this.wrongCode = true
        })
    },
    formatCode (e) {
      const len = String(this.code).length
      if (len > 5) this.code = String(this.code).slice(0, 5)
    }
  }
}
</script>

<style scoped>
  .result {
    position: relative;
    font: 500 14px/1 Museo, sans-serif;
    width: 520px;
    padding: 20px 20px 40px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .activated {
    width: 490px;
  }
  .title {
    font: 700 48px/1 Bebas, sans-serif;
    line-height: 50px;
    margin-bottom: 11px;
  }
  .description {
    font: 500 16px/1 Museo, sans-serif;
  }
  .text {
    font-family: Museo;
    font-size: 22px;
    font-weight: 700;
    font-style: italic;
    font-stretch: normal;
    line-height: 1.23;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
    position: relative;
    margin: 15px;
    padding: 15px;
  }
  .text span {
    display: block;
    margin: 0 15px;
  }
  .sign {
    width: 100%;
    position: relative;
    top: -20px;
    padding-right: 72px;
    text-align: right;
    font-size: 14px;
    font-weight: normal;
    font-style: italic;
  }
  .sign.without-text {
    height: 44px;
    top: 15px;
  }
  .text .commas {
    position: absolute;
  }
  .text .commas.left {
    left: -35px;
    top: 7px;
  }
  .text .commas.right {
    right: -35px;
    bottom: 19px;
  }
  .text .inner {
    max-width: 300px;
  }
  .message {
    font-size: 16px;
    color: rgba(0, 0, 0, .6);
    margin: 0;
    margin-bottom: 10px;
    line-height: 1.25;
    max-width: 340px;
  }
  .card {
    width: 256px;
    height: 160px;
    border-radius: 8px;
    box-shadow: 0px 2px 8px 0 rgba(0, 0, 0, 0.2);
    margin-bottom: 7px;
  }
  .cost {
    font: 700 32px/1 Bebas, sans-serif;
    text-transform: uppercase;
    margin: 10px 0;
  }
  .phone {
    margin-bottom: 10px;
    line-height: 1.12;
  }
  .input {
    margin-bottom: 40px;
  }
  .field {
    background-color: #fafafa;
    border: 1px solid rgba(139, 139, 139, .5);
    border-radius: 0;
    box-shadow: none;
    font-family: inherit;
    height: 45px;
    padding: 0 15px;
    width: 320px;
  }
  .input__label-content {
    line-height: 1.3;
  }
  .input__label-content::after {
    color: rgba(0, 0, 0, .6);
  }
  .code-wrap {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 320px;
  }
  .confirm,
  .resend-wrap {
    display: flex;
  }
  .code-wrap {
    min-height: 90px;
  }
  .code-wrap .message {
    margin-top: auto;
  }
  .confirm {
    align-items: flex-start;
    position: relative;
  }
  .error::after {
    content: 'Неверный код';
    display: inline-block;
    position: absolute;
    top: calc(100% + 3px);
    left: 15px;
    color: #f38b90;
    font-size: 13px;
  }
  .resend-wrap {
    flex-direction: column;
    flex: 1;
  }
  .send .button {
    margin-left: 10px;
  }
  .code {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 123px;
    padding: 0 13px;
    font-size: 16px;
    line-height: 41px;
    border: solid 1px #bcbcbc;
  }
  .error .code {
    color: #f38b90;
    border-color: #f38b90;
  }
  .time {
    color: #000;
  }
  .button {
    background: #FFEE34;
    display: inline-block;
    text-align: center;
    padding: 15px 10px 14px;
    border-radius: 4px;
    overflow: hidden;
    text-transform: uppercase;
    font-weight: 700;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.15);
  }
  .button:hover,
  .button:focus {
    background: #FECA34;
  }
  .button[disabled] {
    opacity: .9;
    color: rgba(0,0,0, .4);
  }
  .button.get-code {
    width: 100%;
  }
  .resend {
    background: transparent;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    color: #b71e5b;
    padding: 7px 5px 5px;
  }

  /*----------- Activated state -----------*/

  .qr {
    width: 120px;
    height: 120px;
    margin-bottom: 15px;
  }
  .tip {
    font-size: 12px;
    margin-bottom: 5px;
  }

  .cvc {
    font: 700 42px/1 Bebas, sans-serif;
    padding: 7px 35px 0;
    margin-bottom: 35px;
    border-radius: 4px;
    background-color: rgba(166, 166, 166, .5);
  }
  .info {
    color: rgba(0, 0, 0, .6);
  }
  .link {
    font-size: 13px;
    font-weight: 700;
    color: #FFEE34;
    text-transform: uppercase;
  }
  .link:hover,
  .link:focus {
    opacity: .6;
  }

  .purple {
    font-weight: bold;
    font-size: 16px;
    color: #FFEE34;
  }

  /*=============================================>>>>>
  = Mobile =
  ===============================================>>>>>*/

  @media screen and (max-width: 1023px) {
    .result {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    .title {
      margin-bottom: 5px;
    }
    .message {
      margin-bottom: 15px;
    }
    .card {
      margin-bottom: 13px;
    }
    .cost {
      margin-bottom: 21px;
    }
    .text {
      padding: 55px 0;
      margin: 0px 10px 15px;
    }
    .text .commas.left {
      left: -20px;
    }
    .text .commas.right {
      right: -20px;
      bottom: 13px;
    }
    .sign {
      top: -20px;
      right: -24px;
    }
    .code-wrap {
      max-width: 100%;
    }
    .send {
      padding-top: 17px;
    }
    .qr {
      margin-bottom: 20px;
    }
    .tip {
      margin-bottom: 8px;
    }
    .cvc {
      margin-bottom: 28px;
    }
    .info {
      line-height: 1.2;
    }
    .input {
      width: 100%;
    }
    .field {
      width: 100%;
    }
  }
  @media screen and (max-width: 320px) {
    .code-wrap {
      max-width: 280px;
    }

    .result {
      padding-right: 20px;
      padding-left: 20px;
    }
  }
</style>
